// import { useEffect } from 'react';
import React, { Component, useState, useRef, useEffect } from 'react';
import { useParams, Outlet } from 'react-router-dom';
import i18n from './i18n';

// import {
//   Button, Container, Row, Col,
//   // Card, CardBody, CardTitle, CardSubtitle, CardText 
// } from 'reactstrap';

// function LanguageSwitcher() {

// export default function LanguageWrapper() {
const LanguageWrapper = () => {
    const { lang } = useParams();


    useEffect(() => {
        if (lang && i18n.language !== lang) {

            // console.log('LanguageWrapper lang = ')
            // console.log(lang)
            // console.log('LanguageWrapper i18n.language = ')
            // console.log(i18n.language)

            // i18n.changeLanguage(lang);

            // console.log('LanguageWrapper = '+lang)
        }
    }, [lang]);

    return <Outlet />;
}

export default LanguageWrapper;